import CustomModal from "../CustomModal";
import { useEffect, useState } from "react";
import axios from "axios";
import { getAuthToken } from "../../../utils/cookieUtils";
import { useLocations } from "../../../hooks/useLocations";

const AddSubscriptionModal = ({
  isOpen,
  onClose,
  currentStep,
  payerName,
  setPayerName,
  gymNumber,
  setGymNumber,
  subscriptionPlan,
  setSubscriptionPlan,
  amountPaid,
  paymentMethod,
  setPaymentMethod,
  selectedPlanName,
  loading,
  onNextStep,
  onBackStep,
  onSubmit,
  handleSubscriptionPlanChange,
}) => {
  const { 
    locations, 
    loading: loadingLocations, 
    isBranchAdmin, 
    currentAdminLocationId 
  } = useLocations(isOpen);
  
  const [locationId, setLocationId] = useState("");
  const [plans, setPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(false);

  useEffect(() => {
    if (isBranchAdmin && currentAdminLocationId && locations.length > 0) {
      setLocationId(currentAdminLocationId.toString());
    }
  }, [isBranchAdmin, currentAdminLocationId, locations]);

  useEffect(() => {
    if (!locationId) return;
    setLoadingPlans(true);
    const token = getAuthToken();
    axios
      .get(`/super-admin/get-subscription-plans?location_id=${locationId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const plans = res.data.message?.subscription_plans;
        setPlans(Array.isArray(plans) ? plans : plans?.data || []);
      })
      .catch(() => setPlans([]))
      .finally(() => setLoadingPlans(false));
  }, [locationId]);

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Add Subscription Modal"
      className="add-admin-modal"
    >
      {currentStep === 1 && (
        <div>
          <div className="add-staff-head">
            <h2>Member details</h2>
          </div>
          <form onSubmit={onNextStep}>
            <div className="inner-form sub-form">
              <label>
                Payer's Name:{" "}
                <input
                  type="text"
                  value={payerName}
                  onChange={(e) => setPayerName(e.target.value)}
                  required
                />
              </label>
              <br />
              <label>
                Gym Number:{" "}
                <input
                  type="text"
                  value={gymNumber}
                  onChange={(e) => setGymNumber(e.target.value)}
                  required
                />
              </label>
              <br />
              {/* Only show location dropdown if user has multiple locations */}
              {!isBranchAdmin && (
                <>
                  <label>
                    Location:
                    <select
                      value={locationId}
                      onChange={e => setLocationId(e.target.value)}
                      required
                      disabled={loadingLocations}
                      style={{ marginBottom: 12 }}
                    >
                      <option value="" disabled>
                        {loadingLocations ? 'Loading locations...' : 'Select a location'}
                      </option>
                      {locations.map(loc => (
                        <option key={loc.id} value={loc.id}>{loc.name}</option>
                      ))}
                    </select>
                  </label>
                  <br />
                </>
              )}
              {/* Show selected location for Branch Admins as read-only info */}
              {isBranchAdmin && locations.length > 0 && (
                <>
                  <label>
                    Location: <strong>{locations[0]?.name}</strong>
                  </label>
                  <br />
                </>
              )}
              <label>
                Subscription Plan:{" "}
                <select
                  value={subscriptionPlan}
                  onChange={handleSubscriptionPlanChange}
                  required
                  disabled={loadingPlans}
                >
                  <option value="">{loadingPlans ? 'Loading plans...' : 'Select Subscription Plan'}</option>
                  {plans.map((plan, index) => (
                    <option key={index} value={plan.id}>
                      {plan.name}
                    </option>
                  ))}
                </select>
              </label>
              <br />
              <label>
                Amount Paid:{" "}
                <input type="number" value={amountPaid} readOnly required />
              </label>
              <br />
              <label>
                Payment Method:{" "}
                <select
                  value={paymentMethod}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  required
                >
                  <option value="">Select Payment Method</option>
                  <option value="POS Payment">POS</option>
                  <option value="Bank Transfer">Bank Transfer</option>
                </select>
              </label>
              <br />
            </div>
            <div className="modal-button">
              <button type="button" onClick={onClose}>
                Cancel
              </button>
              <input type="submit" value="Next" />
            </div>
          </form>
        </div>
      )}
      {currentStep === 2 && (
        <div className="sub-confirm">
          <div className="add-staff-head">
            <h2>Payment Overview</h2>
          </div>
          <img
            src={`${process.env.PUBLIC_URL}/images/payment-overview.png`}
            alt="Payment overview icon"
          />
          <div className="details-container container">
            <div className="detail">
              <p>Payer's Name</p>
              <b>
                <p className="D">{payerName}</p>
              </b>
            </div>
            <div className="detail">
              <p>Gym Number</p>
              <b>
                <p className="D">{gymNumber}</p>
              </b>
            </div>
            <div className="detail">
              <p>Location</p>
              <b>
                <p className="D">{locations.find(l => l.id === Number(locationId))?.name || ''}</p>
              </b>
            </div>
            <div className="detail">
              <p>Subscription Plan</p>
              <b>
                <p className="D">{plans.find(p => p.id === Number(subscriptionPlan))?.name || ''}</p>
              </b>
            </div>
            <div className="detail">
              <p>Payment Method</p>
              <b>
                <p className="D">{paymentMethod}</p>
              </b>
            </div>
            <div className="detail">
              <p>Amount Paid</p>
              <b>
                <p className="D">{amountPaid}</p>
              </b>
            </div>
          </div>
          <div className="modal-button">
            <button type="button" onClick={onBackStep}>
              Back
            </button>
            <button
              type="submit"
              onClick={onSubmit}
              style={{ backgroundColor: "#0473bd", color: "white" }}
            >
              Complete
            </button>
          </div>
        </div>
      )}
    </CustomModal>
  );
};

export default AddSubscriptionModal;
